import React from "react";

import { DynamicForm } from "src/components/Form";

import { contactFields } from "./fields";

const fields = options => ({ t }) => [
  {
    type: "section",
    title: t("forms.ContactInformationSectionTitle"),
    fields: [
      ...contactFields({ t, includeAccountNumber: false }),
      {
        key: "appointmentType",
        label: t("forms.appointment.appointmentTypeLabel"),
        placeholder: t("forms.appointment.appointmentTypePlaceholder"),
        required: true,
        type: "dropdown",
        inputProps: {
          options,
        },
      },
      {
        key: "bestAppointmentTime",
        label: t("forms.appointment.bestAppointmentTimeLabel"),
        required: true,
      },
    ],
  },
];

const AppointmentForm = ({ moduleKey, options }) => (
  <DynamicForm
    formKey={options.formKey || moduleKey}
    fields={fields(options.options)}
    defaultSuccessMessageKey="forms.defaultSuccessMessage"
  />
);

export default AppointmentForm;



// WEBPACK FOOTER //
// ./src/components/Content/forms/AppointmentForm.js